import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import StdReportEditor from './editor';
import { WinManagerContext } from '../../providers';

function StdRouterReportEditor({ id, url }) {
  const {
    dellComponentFromWindowsManager,
  } = useContext(WinManagerContext);
  return (
    <StdReportEditor
      reportId={id}
      url={url}
      onClose={() => dellComponentFromWindowsManager(url)}
    />
  );
}

StdRouterReportEditor.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default StdRouterReportEditor;
